import { KEYCODE_MAP_HFD_LAYOUT } from "./keyCodeMapperHfd";
import { resolveHfdFnFuncDisplayKeyCode } from "./hfdFnDisplay";

/** matrix (row,col) → Fn 层展示用 keyCode（对齐 SMART875 出厂 Fn 图 / 竞品驱动） */
const SMART875_FN_CELL_OVERRIDES: Readonly<Record<string, number>> = {
  // Row 1 — 数字行
  "1,13": resolveHfdFnFuncDisplayKeyCode(12294, { v2: true }), // Backspace 关闭灯光
  // Row 2 — Tab / QWER … \| [ ] End·PgDn
  "2,0": resolveHfdFnFuncDisplayKeyCode(93, { v2: false }), // Tab 一键白光
  "2,1": resolveHfdFnFuncDisplayKeyCode(8192, { v2: true }), // Q 蓝牙通道1
  "2,2": resolveHfdFnFuncDisplayKeyCode(8193, { v2: true }), // W 蓝牙通道2
  "2,3": resolveHfdFnFuncDisplayKeyCode(8194, { v2: true }), // E 蓝牙通道3
  "2,4": resolveHfdFnFuncDisplayKeyCode(8202, { v2: true }), // R 无线回连
  "2,13": resolveHfdFnFuncDisplayKeyCode(12288, { v2: true }), // \|（keycode 49）灯光效果切换
  "2,14": resolveHfdFnFuncDisplayKeyCode(27, { v2: false }), // End 正面灯条效果切换
  "2,15": resolveHfdFnFuncDisplayKeyCode(29, { v2: false }), // PgDn 正面灯条颜色切换
  // Row 3 — Caps / ASDF … Enter
  "3,0": resolveHfdFnFuncDisplayKeyCode(4096, { v2: true }), // Caps 恢复出厂设置
  "3,1": resolveHfdFnFuncDisplayKeyCode(8, { v2: false }), // A WIN
  "3,2": resolveHfdFnFuncDisplayKeyCode(9, { v2: false }), // S MAC
  "3,13": resolveHfdFnFuncDisplayKeyCode(12289, { v2: true }), // Enter 灯光颜色切换
  // Row 4 — Shift / ZXCV … ↑
  "4,15": resolveHfdFnFuncDisplayKeyCode(12290, { v2: true }), // ↑ 灯光亮度+
  // Row 5 — 底行 / 方向键
  "5,1": resolveHfdFnFuncDisplayKeyCode(22, { v2: false }), // L-Win 锁定Win
  "5,10": resolveHfdFnFuncDisplayKeyCode(7, { v2: false }), // R-Alt 查询电量
  "5,13": resolveHfdFnFuncDisplayKeyCode(12293, { v2: true }), // ← 灯光速度-
  "5,14": resolveHfdFnFuncDisplayKeyCode(12291, { v2: true }), // ↓ 灯光亮度-
  "5,15": resolveHfdFnFuncDisplayKeyCode(12292, { v2: true }), // → 灯光速度+
};

const SMART875_BASE_MATRIX = KEYCODE_MAP_HFD_LAYOUT["84"];

function readSmart875EquipmentFlag(): boolean {
  try {
    const raw = localStorage.getItem("equipmentData");
    if (!raw) return false;
    const eq = JSON.parse(raw) as {
      displayname?: string;
      productName?: string;
      keyboardType?: string;
    };
    const name = String(eq?.displayname ?? eq?.productName ?? "").trim();
    return name === "SMART875" || String(eq?.keyboardType ?? "") === "84";
  } catch {
    return false;
  }
}

export function buildHuafendaSmart875FnLayerKeyCodes(): number[][] {
  return SMART875_BASE_MATRIX.map((row, rowIndex) =>
    row.map((baseCell, col) => {
      const overrideKey = `${rowIndex},${col}`;
      if (
        Object.prototype.hasOwnProperty.call(
          SMART875_FN_CELL_OVERRIDES,
          overrideKey
        )
      ) {
        return SMART875_FN_CELL_OVERRIDES[overrideKey];
      }
      if (baseCell === 0) return 0;
      return baseCell;
    })
  );
}

export function applyHuafendaSmart875FnLayerToSdkRows(
  rows: { layer: number; row: number; keyboardLayout: number[] }[]
): { layer: number; row: number; keyboardLayout: number[] }[] {
  const fnMatrix = buildHuafendaSmart875FnLayerKeyCodes();
  return rows.map((row) => {
    const staticRow = fnMatrix[row.row];
    if (!staticRow) return row;
    return { ...row, keyboardLayout: [...staticRow] };
  });
}

/** SMART875（84）Fn 层使用静态出厂映射表 */
export function shouldApplyHuafendaSmart875FnLayer(
  keyboardType: string,
  layer: number
): boolean {
  if (layer === 0) return false;
  if (keyboardType === "84") return true;
  return readSmart875EquipmentFlag();
}

export function getHuafendaSmart875FnLayerRow(
  rowIndex: number
): number[] | null {
  const matrix = buildHuafendaSmart875FnLayerKeyCodes();
  return matrix[rowIndex] ?? null;
}
